<template>
  <div>
    <div class="mb-4">
      Хотелось бы сказать спасибо разработчикам и создателям приложения МедТочка. Для нас, для компании и меня
      лично, это приложение оказалось очень полезным.
    </div>
    <div class="mb-4">
      Пациент, приходя на приём, может открыть доступ врачу в свою электронную медицинскую карту, и я могу
      посмотреть все необходимые обследования, которые прошёл пациент. Не нужно носить с собой целую папку с
      анализами и заключениями — всё здесь, удобно и современно.
    </div>
    <div class="mb-4">
      Назначая дату повторного приёма, я могу быть спокойна, что пациент о нём не забудет, приложение МедТочка ему
      обязательно напомнит.
    </div>
    <div>
      Многие люди сейчас подкованы в плане современных технологий и с удовольствием скачивают приложение, а для
      тех, кто сомневается, мы стараемся подробно объяснить полезность МедТочки. Сейчас нужно идти в ногу со
      временем, и я рада, что наши партнёры разрабатывают такие удобные приложения как для нас, врачей, так и для
      пациентов.
    </div>
  </div>
</template>
